import React from 'react';
const Shopping = () => (React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M5.5 12l5.792-8.886a.247.247 0 01.416 0L17.5 12M1 12l3.5 11h14L22 12H1zM11.5 16v3M7.5 16v3M15.5 16v3" }))));
export default Shopping;
//# sourceMappingURL=Shopping.js.map